/* Rugged Print, product page template behavior (sections/main-product-rugged.liquid).
   Add to Cart itself is NOT handled here -- the real <product-form> + product-form.js
   (already loaded site-wide) owns that, so every add-to-cart on this page uses the same
   tested path as every other product page and opens the site's existing cart notification/
   drawer. This file only drives presentation: variant price/callout/sold-out state,
   gallery thumbnail swap, the description parser, FAQ accordion and the delivery estimate. */
(function(){
  'use strict';

  /* ---------- description parser, ported verbatim from module-05b/template.js ----------
     Keeps every word of the stored description: the full sanitized HTML is always rendered,
     and if the parse does not account for (almost) all of the text, the full description is
     shown open instead of collapsed, so no product ever loses content. */
  var KEEP = { P:1, H2:1, H3:1, H4:1, H5:1, STRONG:1, B:1, EM:1, I:1, BR:1, DIV:1, SPAN:1, UL:1, OL:1, LI:1, A:1 };
  function sanitize(node){
    Array.prototype.slice.call(node.children).forEach(function(el){
      if (!KEEP[el.tagName]){ el.replaceWith(document.createTextNode(el.textContent)); return; }
      Array.prototype.slice.call(el.attributes).forEach(function(a){
        if (!(el.tagName === 'A' && a.name === 'href')) el.removeAttribute(a.name);
      });
      sanitize(el);
      if (el.tagName === 'SPAN' && !el.textContent.trim() && !el.children.length) el.remove();
    });
  }
  function textOf(el){ return (el.textContent || '').replace(/\s+/g, ' ').trim(); }
  function splitSentences(s){ return s.split(/(?<=[.!?]["”']?)\s+(?=[A-Z0-9‘“])/).map(function(x){ return x.trim(); }).filter(Boolean); }

  function parseDescription(html){
    var holder = document.createElement('div');
    holder.innerHTML = html;
    sanitize(holder);
    var body = holder;
    while (body.children.length === 1 && body.firstElementChild.tagName === 'DIV') body = body.firstElementChild;

    var out = { full: holder.innerHTML, intro: [], features: [], featuresHeading: '', sections: [], included: [], notIncluded: [], includedLabel: '', metas: [], covered: 0, total: textOf(holder).length };
    var seenHeading = false;
    var kids = Array.prototype.slice.call(body.children);
    for (var i = 0; i < kids.length; i++){
      var el = kids[i];
      if (/^H[2-5]$/.test(el.tagName)){
        seenHeading = true;
        var head = textOf(el), next = kids[i + 1];
        if (!next) continue;
        var items = [];
        if (next.tagName === 'UL' || next.tagName === 'OL'){
          items = Array.prototype.slice.call(next.children).map(function(li){ return { label: '', text: textOf(li) }; });
        } else {
          Array.prototype.slice.call(next.children).forEach(function(item){
            var strong = item.querySelector('strong,b');
            var label = strong ? textOf(strong) : '';
            var rest = textOf(item).slice(label.length).trim();
            items.push({ label: label.replace(/:\s*$/, ''), text: rest });
          });
        }
        if (/key features|features/i.test(head) && !out.features.length){ out.features = items; out.featuresHeading = head; }
        else out.sections.push({ heading: head, items: items });
        out.covered += textOf(el).length + textOf(next).length;
        i++; continue;
      }
      if (el.tagName === 'P' && !seenHeading){ out.intro.push(el.innerHTML.trim()); out.covered += textOf(el).length; continue; }
      if (el.tagName === 'DIV'){
        Array.prototype.slice.call(el.children).forEach(function(pair){
          if (pair.children.length < 2) return;
          var label = textOf(pair.children[0]);
          var valueEl = pair.children[1];
          out.covered += textOf(pair).length;
          if (/what.?s included/i.test(label)){
            out.includedLabel = label;
            valueEl.innerHTML.split(/<br\s*\/?>/i).forEach(function(line){
              var t = document.createElement('div'); t.innerHTML = line;
              splitSentences(textOf(t)).forEach(function(sent){
                if (/not included/i.test(sent)){
                  sent.replace(/\b(are|is)?\s*not included\.?$/i, '').split(/,\s*(?:and\s+)?|\s+and\s+/).forEach(function(x){
                    x = x.trim(); if (x) out.notIncluded.push(x.charAt(0).toUpperCase() + x.slice(1));
                  });
                } else out.included.push(sent);
              });
            });
          } else {
            out.metas.push({ label: label, value: textOf(valueEl) });
          }
        });
        continue;
      }
      if (el.tagName === 'P'){ out.sections.push({ heading: '', items: [{ label: '', text: textOf(el) }] }); out.covered += textOf(el).length; }
    }
    out.structured = out.features.length > 0 || out.included.length > 0;
    out.coverage = out.total ? out.covered / out.total : 1;
    return out;
  }

  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

  function renderDetails(root){
    var holder = root.querySelector('[data-pdp-description-raw]');
    var mount = root.querySelector('[data-pdp-details-mount]');
    if (!holder || !mount) return;
    var d = parseDescription(holder.innerHTML);
    var h = '';
    if (d.intro.length) d.intro.forEach(function(p){ h += '<p class="pdp-details-intro">' + p + '</p>'; });
    if (d.features.length){
      h += '<h4>' + esc(d.featuresHeading || 'Key Features') + '</h4><div class="pdp-feature-grid">' +
        d.features.map(function(f){ return '<div class="item"><span class="dot"></span><span>' + (f.label ? '<b>' + esc(f.label) + '</b>' : '') + esc(f.text) + '</span></div>'; }).join('') + '</div>';
    }
    if (d.included.length || d.notIncluded.length){
      h += '<div class="pdp-inbox">' +
        '<div class="pdp-inbox-col"><h4>What\'s included</h4><ul class="pdp-inbox-list yes">' + d.included.map(function(x){ return '<li><i class="fa-solid fa-check" aria-hidden="true"></i><span>' + esc(x) + '</span></li>'; }).join('') + '</ul></div>' +
        (d.notIncluded.length ? '<div class="pdp-inbox-col"><h4>Not included</h4><ul class="pdp-inbox-list no">' + d.notIncluded.map(function(x){ return '<li><i class="fa-solid fa-xmark" aria-hidden="true"></i><span>' + esc(x) + '</span></li>'; }).join('') + '</ul></div>' : '') +
        '</div>';
    }
    d.sections.forEach(function(s){
      h += (s.heading ? '<h4>' + esc(s.heading) + '</h4>' : '') + '<ul class="pdp-plainlist">' + s.items.map(function(it){ return '<li>' + (it.label ? '<b>' + esc(it.label) + ':</b> ' : '') + esc(it.text) + '</li>'; }).join('') + '</ul>';
    });
    if (d.metas.length){
      h += '<div class="pdp-meta-row">' + d.metas.map(function(m){ return '<div><div class="meta">' + esc(m.label) + '</div><div class="val">' + esc(m.value) + '</div></div>'; }).join('') + '</div>';
    }
    var fallbackOpen = !d.structured || d.coverage < 0.97;
    if (!d.structured){
      mount.innerHTML = '<div class="pdp-fulldesc">' + d.full + '</div>';
    } else {
      mount.innerHTML = h + '<details class="pdp-fulldesc-wrap"' + (fallbackOpen ? ' open' : '') + '><summary>Full description, exactly as listed</summary><div class="pdp-fulldesc">' + d.full + '</div></details>';
    }
  }

  /* ---------- delivery estimate ---------- */
  var SETTINGS = { shipMinDays: 1, shipMaxDays: 3, transitMinDays: 3, transitMaxDays: 7 };
  function addBusinessDays(date, days){
    var d = new Date(date), added = 0;
    while (added < days){ d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) added++; }
    return d;
  }
  function formatShort(d){ return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
  function deliveryRangeText(){
    var today = new Date();
    var shipBy = addBusinessDays(today, SETTINGS.shipMaxDays);
    var earliest = addBusinessDays(today, SETTINGS.shipMinDays + SETTINGS.transitMinDays);
    var latest = addBusinessDays(today, SETTINGS.shipMaxDays + SETTINGS.transitMaxDays);
    return 'Ships by ' + formatShort(shipBy) + '. Arrives ' + formatShort(earliest) + ' to ' + formatShort(latest) + '.';
  }

  function wireRoot(root){
    root.querySelectorAll('[data-delivery-range]').forEach(function(el){ el.textContent = deliveryRangeText(); });

    /* ---------- variant option buttons: price, fit callout, sold-out state ----------
       Drives the REAL hidden variant-id input inside the real <product-form>, so the
       genuine Shopify Add to Cart button always submits the variant shown on screen. */
    function applyVariant(btn){
      var priceEl = root.querySelector('.pdp-price .now');
      var stickyPriceEl = root.querySelector('.pdp-mobile-sticky .price');
      var callout = root.querySelector('.pdp-fitbox [data-callout]');
      var price = btn.getAttribute('data-price');
      if (price){
        if (priceEl) priceEl.textContent = '$' + price;
        if (stickyPriceEl) stickyPriceEl.textContent = '$' + price;
      }
      if (callout){
        var txt = btn.getAttribute('data-callout') || '';
        callout.textContent = txt;
        callout.style.display = txt ? '' : 'none';
      }
      var idInput = root.querySelector('.product-variant-id');
      if (idInput) idInput.value = btn.getAttribute('data-variant-id');
      var available = btn.getAttribute('data-available') === 'true';
      var tag = root.querySelector('[data-soldout-tag]');
      if (tag) tag.hidden = available;
      root.querySelectorAll('[data-atc]').forEach(function(atc){
        atc.disabled = !available;
        atc.setAttribute('aria-disabled', String(!available));
        atc.querySelectorAll('span').forEach(function(s){ s.textContent = available ? window.RP_PDP_I18N.addToCart : window.RP_PDP_I18N.soldOut; });
      });
      root.querySelectorAll('.pdp-qty .quantity__button, .pdp-qty .quantity__input').forEach(function(el){ el.disabled = !available; });
      var sticky = root.querySelector('.pdp-mobile-sticky');
      if (sticky) sticky.classList.toggle('is-soldout', !available);
    }
    root.querySelectorAll('.pdp-options-row').forEach(function(row){
      row.querySelectorAll('.pdp-option-btn').forEach(function(btn){
        btn.addEventListener('click', function(){
          row.querySelectorAll('.pdp-option-btn').forEach(function(b){ b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');
          applyVariant(btn);
        });
      });
    });

    /* ---------- gallery thumbnail swap ---------- */
    root.querySelectorAll('.pdp-gallery').forEach(function(gallery){
      var main = gallery.querySelector('.pdp-gallery-main img');
      gallery.querySelectorAll('.pdp-gallery-thumbs img').forEach(function(thumb){
        thumb.addEventListener('click', function(){
          gallery.querySelectorAll('.pdp-gallery-thumbs img').forEach(function(t){ t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          if (main) { main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = thumb.getAttribute('data-full') || thumb.src; }
        });
      });
    });

    /* ---------- FAQ accordion ---------- */
    root.querySelectorAll('.pdp-faq-q').forEach(function(q){
      q.addEventListener('click', function(){ q.closest('.pdp-faq-item').classList.toggle('is-open'); });
    });

    /* ---------- guarantee "Details" toggle ---------- */
    root.querySelectorAll('[data-guarantee-toggle]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var details = root.querySelector('[data-guarantee-details]');
        if (details) details.classList.toggle('is-open');
      });
    });

    /* ---------- toast (shared by wishlist + share) ---------- */
    var toastEl = document.querySelector('[data-rp-toast]'), toastTimer;
    function toast(msg){
      if (!toastEl) return;
      toastEl.textContent = msg; toastEl.hidden = false; toastEl.classList.add('is-on');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function(){ toastEl.classList.remove('is-on'); toastEl.hidden = true; }, 2600);
    }

    /* ---------- wishlist: uses the theme's own wishlist (lumin-main.js, localStorage "lumin-wishlist") ---------- */
    function wishlistItems(){
      try { var a = JSON.parse(localStorage.getItem('lumin-wishlist') || '[]'); return Array.isArray(a) ? a : []; } catch(e){ return []; }
    }
    function paintSave(btn){
      var on = wishlistItems().some(function(x){ return x.url === btn.getAttribute('data-product-url'); });
      var icon = btn.querySelector('i');
      btn.classList.toggle('is-saved', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Save to wishlist');
      btn.setAttribute('title', on ? 'Saved. Click to remove' : 'Save to wishlist');
      if (icon){ icon.classList.toggle('fa-regular', !on); icon.classList.toggle('fa-solid', on); }
    }
    root.querySelectorAll('[data-action="save"]').forEach(function(btn){
      paintSave(btn);
      window.addEventListener('storage', function(){ paintSave(btn); });
      btn.addEventListener('click', function(){
        var box = document.querySelector('lumin-wishlist-container');
        if (!box || typeof box.setProduct !== 'function'){ toast('Wishlist is not available right now'); return; }
        var was = btn.classList.contains('is-saved');
        btn.disabled = true;
        Promise.resolve(box.setProduct(btn.getAttribute('data-product-url'))).then(function(){
          paintSave(btn);
          toast(btn.classList.contains('is-saved') ? 'Saved to your wishlist' : (was ? 'Removed from your wishlist' : 'Could not save, try again'));
        }).catch(function(){ toast('Could not save, try again'); }).then(function(){ btn.disabled = false; });
      });
    });

    /* ---------- share: native share sheet where available, otherwise copy the link ---------- */
    function copyText(text){
      function legacy(){
        return new Promise(function(res, rej){
          var t = document.createElement('textarea'); t.value = text; t.setAttribute('readonly','');
          t.style.cssText = 'position:fixed;top:0;left:0;opacity:0'; document.body.appendChild(t); t.select();
          var ok = false; try { ok = document.execCommand('copy'); } catch(e){}
          document.body.removeChild(t); ok ? res() : rej();
        });
      }
      if (navigator.clipboard && navigator.clipboard.writeText){
        /* clipboard API can hang or be refused (no focus, permissions): fall back after 1.2s or on refusal */
        return new Promise(function(res, rej){
          var done = false;
          var timer = setTimeout(function(){ if (!done){ done = true; legacy().then(res, rej); } }, 1200);
          navigator.clipboard.writeText(text).then(function(){ if (!done){ done = true; clearTimeout(timer); res(); } },
            function(){ if (!done){ done = true; clearTimeout(timer); legacy().then(res, rej); } });
        });
      }
      return legacy();
    }
    root.querySelectorAll('[data-action="share"]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var data = { title: btn.getAttribute('data-share-title'), url: btn.getAttribute('data-share-url') };
        if (navigator.share){
          navigator.share(data).catch(function(err){
            if (err && err.name === 'AbortError') return;
            copyText(data.url).then(function(){ toast('Link copied'); }, function(){ toast('Could not copy the link'); });
          });
        } else {
          copyText(data.url).then(function(){ toast('Link copied'); }, function(){ toast('Could not copy the link'); });
        }
      });
    });

    renderDetails(root);
  }

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.rp-pdp').forEach(wireRoot);
  });
})();
